import * as RadixDropdown from '@radix-ui/react-dropdown-menu'
import { ComponentProps, FC } from 'react'

export const Portal: FC<ComponentProps<typeof RadixDropdown.Portal>> = ({ children, ...rest }) => {
  return <RadixDropdown.Portal {...rest}>{children}</RadixDropdown.Portal>
}
